export default __webpack_public_path__ + "static/media/p3.f87bd290.png";